// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OrderDetailPanel — work order detail sliding over the list. */

/* Pinned to the window, not the page: the list scrolls the whole window,
   and an absolute panel the height of a long list scrolled its own content
   out of view. Fixed, the panel is always one screen tall and its body
   scrolls instead. Above the top bar (z 12), like the other overlays. */
.od-wrap {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  justify-content: flex-end;
}
.od-scrim {
  position: absolute;
  inset: 0;
  /* the list behind still scrolls under the wheel; the panel stays put */
  background: rgba(25, 23, 20, 0.18);
}
.od-panel {
  position: relative;
  width: 840px;
  max-width: 100%;
  background: #fff;
  border-left: 1px solid #ddd7cb;
  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.14);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ---------------- header ---------------- */
.od-head {
  padding: 18px 24px 16px;
  border-bottom: 1px solid #e2dcd0;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex-shrink: 0;
  /* style.css styles bare <header> tags (bold, centered, margins) for the
     legacy pages — reset so the name and sub line sit left with the meta. */
  text-align: left;
  font-weight: 400;
  margin: 0;
}
.od-head-main {
  flex-grow: 1;
  min-width: 0;
}
.od-meta {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 5px;
}
.od-serial {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8b8477;
}
.od-type {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 4px;
}
.od-type.is-funeral {
  color: var(--rf-brand-deep);
  background: var(--rf-brand-tint);
}
.od-type.is-retail {
  color: var(--rf-accent);
  background: #e9f1f0;
}
.od-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #4a453c;
}
.od-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.od-name {
  font-size: 30px;
  line-height: 1.1;
  color: #191714;
  margin: 0;
  font-weight: 400;
}
.od-sub {
  font-size: 13px;
  color: #6f6a60;
  margin-top: 5px;
  text-wrap: pretty;
}
.od-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.od-actions .rf-btn {
  height: 34px;
  font-size: 12.5px;
}
.rf-icon-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8b8477;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
}
.rf-icon-btn:hover {
  background: #f4f1ea;
}

/* ---------------- body ---------------- */
.od-body {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ---------------- timeline ---------------- */
.od-timeline {
  background: #faf8f3;
  border: 1px solid #eee9df;
  border-radius: 12px;
  padding: 14px 18px;
  display: flex;
  align-items: flex-start;
}
.od-step {
  flex-grow: 1;
  padding-right: 14px;
  min-width: 0;
}
.od-step-track {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.od-step-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e0dacd;
  flex-shrink: 0;
}
.od-step-line {
  flex-grow: 1;
  height: 2px;
  background: #e2dcd0;
}
.od-step.is-done .od-step-dot,
.od-step.is-done .od-step-line {
  background: #4d7a52;
}
.od-step.is-active .od-step-dot {
  background: #b0872f;
}
.od-step-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #a29b8d;
}
.od-step.is-done .od-step-label,
.od-step.is-active .od-step-label {
  color: #191714;
}
.od-step-time {
  font-size: 11.5px;
  color: #a29b8d;
}

/* ---------------- facts ---------------- */
.od-facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.od-facts-label {
  margin-bottom: 8px;
  display: block;
}
.od-factcard {
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  overflow: hidden;
}
.od-fact {
  display: flex;
  gap: 12px;
  padding: 9px 13px;
  border-top: 1px solid #f0ece3;
  font-size: 13px;
}
.od-fact:first-child {
  border-top: none;
}
.od-fact-k {
  width: 118px;
  flex-shrink: 0;
  color: #8b8477;
}
.od-fact-v {
  color: #191714;
  font-weight: 500;
  text-wrap: pretty;
}
.od-fact-v.is-danger {
  color: #a8483e;
}
/* a second line under the value — the orderer's phone under their name */
.od-fact-sub {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #6f6a60;
}
.od-fact-v.is-muted {
  color: #6f6a60;
}

/* ---------------- products ---------------- */
.od-products-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 8px;
}
.od-products-total {
  font-size: 12.5px;
  color: #8b8477;
}
.od-products-total b {
  color: #191714;
  font-weight: 600;
}
.od-productcard {
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  overflow: hidden;
}
.od-product {
  padding: 11px 14px;
  border-top: 1px solid #f0ece3;
}
.od-product-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
/* sash wording, bench comment and lid type under the product — full
   width so a sentence reads as one, indented past the accent bar */
.od-product-notes {
  margin: 7px 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.od-product-note {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.4;
}
.od-product-note-k {
  width: 62px;
  flex-shrink: 0;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--rf-brand);
}
.od-product-note-v {
  color: #2f2b25;
  overflow-wrap: anywhere;
}
.od-product-note-v em {
  color: #a8483e;
  font-style: normal;
  font-weight: 600;
}
/* sash wording and bench comment: free text, set apart from the facts */
.od-product-note.is-text .od-product-note-v {
  font-style: italic;
  font-weight: 400;
  color: #6b6458;
}
/* bench comments are instructions — red so they aren't missed */
.od-product-note.is-comment .od-product-note-v {
  color: #a8483e;
}
.od-product:first-child {
  border-top: none;
}
.od-product-accent {
  width: 4px;
  height: 30px;
  border-radius: 2px;
  flex-shrink: 0;
}
/* the name takes up to 70% of the card before it wraps; qty and price
   are pushed to the right edge */
.od-product-text {
  flex: 0 1 70%;
  max-width: 70%;
  min-width: 0;
  margin-right: auto;
}
.od-product-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
}
.od-product-meta {
  font-size: 11.5px;
  color: #a29b8d;
}
.od-product-qty {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 13px;
  color: #4a453c;
}
.od-product-price {
  min-width: 74px;
  flex-shrink: 0;
  text-align: right;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
/* "2 × \$440.00 each + sash \$30.00" — right under the line total */
.od-product-calc {
  margin-top: 3px;
  text-align: right;
  font-size: 12px;
  color: #6f6a60;
}
.od-product-foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.od-product-who {
  font-size: 11px;
  color: #4a453c;
}
.od-product-state {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 2px 7px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}
.od-product-state.is-ok {
  color: #4d7a52;
  background: #eaf1e9;
}
.od-product-state.is-warn {
  color: #b0872f;
  background: #f9f1de;
}
.od-product-state.is-idle {
  color: #8b8477;
  background: #f4f1ea;
}

/* ---------------- footer ---------------- */
.od-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0 4px;
  font-size: 12px;
  color: #a29b8d;
}
.od-delete {
  border: none;
  background: none;
  padding: 0;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #a8483e;
  cursor: pointer;
}

/* ---------------- responsive: tablet ---------------- */
@media (max-width: 1200px) {
  .od-panel {
    width: 100%;
  }
  .od-facts {
    grid-template-columns: 1fr;
  }
  .od-timeline {
    flex-wrap: wrap;
    gap: 10px;
  }
}

/* ---------------- history view ---------------- */
.od-history {
  gap: 14px;
}
.od-hist-intro {
  font-size: 12.5px;
  color: #6f6a60;
}
.od-hist-count {
  margin-left: 8px;
  font-size: 11.5px;
  color: #a29b8d;
}
.od-hist-state {
  padding: 14px 16px;
  border: 1px dashed #e2dcd0;
  border-radius: 10px;
  font-size: 12.5px;
  color: #6f6a60;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.od-hist-state.is-error {
  border-style: solid;
  border-color: #e8c6c0;
  background: #fbf3f1;
  color: #8a3b2f;
}
.od-hist-retry {
  margin-left: auto;
}
.od-hist-more {
  align-self: flex-start;
  margin-top: 2px;
}
.od-hist-list {
  display: flex;
  flex-direction: column;
}
.od-hist-node {
  display: flex;
  gap: 13px;
}
.od-hist-track {
  width: 30px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.od-hist-dot {
  width: 11px;
  height: 11px;
  margin-top: 4px;
  border-radius: 50%;
  border: 2px solid var(--rf-brand-lite);
  background: #fff;
  flex-shrink: 0;
}
.od-hist-node.is-create .od-hist-dot {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
}
.od-hist-node.is-handover .od-hist-dot,
.od-hist-node.is-run .od-hist-dot {
  background: var(--rf-brand-lite);
}
.od-hist-node.is-delete .od-hist-dot {
  background: #c25a48;
  border-color: #c25a48;
}
.od-hist-node.is-delete .od-hist-action {
  color: #8a3b2f;
}

/* business section marker. The trail is newest first, so a marker sits
   BELOW the entries it belongs to: read bottom-up it opens the section,
   the way the chronology runs. The same line passes through it, so a
   handover reads as a new chapter. */
.od-hist-bizchip {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.od-hist-bizchip img {
  max-width: 24px;
  max-height: 24px;
  object-fit: contain;
}
.od-hist-bizchip span {
  font: 700 11px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand-deep);
}
.od-hist-bizcard {
  padding-bottom: 14px;
}
.od-hist-node.is-business:not(:first-child) .od-hist-bizcard {
  padding-top: 2px;
}
.od-hist-bizeyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}
.od-hist-bizname {
  font-size: 17px;
  color: #191714;
  margin-top: 2px;
}
.od-hist-line {
  flex-grow: 1;
  width: 1.5px;
  background: #e7e3da;
  margin: 3px 0;
}
.od-hist-card {
  flex-grow: 1;
  min-width: 0;
  padding: 0 0 18px;
}
.od-hist-node:last-child .od-hist-card {
  padding-bottom: 4px;
}
.od-hist-toprow {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.od-hist-action {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.od-hist-when {
  margin-left: auto;
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
}
.od-hist-who {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 5px;
  font-size: 12.5px;
  color: #4a453c;
}
.od-hist-chip {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f0e3c8;
  color: var(--rf-brand-deep);
  font: 700 10px "Instrument Sans", Helvetica, Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.od-hist-chip.is-system {
  background: #ecebe7;
  color: #6f6a60;
}
.od-hist-summary {
  margin-top: 5px;
  font-size: 12.5px;
  line-height: 1.5;
  color: #6f6a60;
  text-wrap: pretty;
}
.od-hist-changes {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12.5px;
  line-height: 1.45;
}
.od-hist-changes li {
  display: flex;
  flex-direction: column;
  padding: 4px 0 0;
  border-top: 1px dashed #e6e3dc;
}
.od-hist-changes li:first-child {
  border-top: 0;
  padding-top: 0;
}
.od-hist-field {
  font-weight: 600;
  color: #3d3a33;
}
.od-hist-diff {
  color: #6f6a60;
  overflow-wrap: anywhere;
}
.od-hist-arrow {
  color: #a8a296;
  margin: 0 2px;
}

/* ---------------- transfers ----------------
   The order arrived from another business, or is on its way to one. Both
   sit in the panel head area so they read before anything else. */
.od-from {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 2px 10px;
  border-radius: 11px;
  background: #f3ece0;
  border: 1px solid #e4d8c2;
  color: var(--rf-brand-deep);
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.od-from::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--rf-brand-lite);
}

.od-txbanner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 26px;
  background: #fbf3e2;
  border-bottom: 1px solid #ecdcb8;
}
.od-txbanner-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #c79a2f;
  flex-shrink: 0;
  box-shadow: 0 0 0 4px rgba(199, 154, 47, 0.16);
}
.od-txbanner-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}
.od-txbanner-text b {
  font-size: 13px;
  color: var(--rf-brand-deep);
}
.od-txbanner-text span {
  font-size: 12px;
  color: #8a7f6a;
}
.od-txbanner .rf-btn {
  flex-shrink: 0;
}

.od-hist-node.is-transfer .od-hist-dot {
  background: #6f8fa8;
  border-color: #6f8fa8;
}
.od-hist-node.is-transfer .od-hist-action {
  color: #40617a;
}

/* ---------- order total (mirrors .rv-total-card on the review step) ---------- */
.od-total {
  width: 60%;
  align-self: flex-end;
  margin-top: 100px;
  background: #191714;
  border-radius: 12px;
  padding: 18px 20px;
  color: #fff;
}
@media (max-width: 720px) {
  .od-total {
    width: 100%;
  }
}
.od-total-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  margin-bottom: 12px;
}
.od-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-top: 1px solid #302b23;
  font-size: 12.5px;
}
.od-total-row span:first-child {
  color: #b8b1a3;
}
.od-total-row span:last-child {
  color: #fff;
  font-variant-numeric: tabular-nums;
}
.od-total-row.is-total {
  font-size: 16px;
  font-weight: 600;
}
.od-total-row.is-total span:first-child {
  color: #fff;
}
.od-total-row.is-total span:last-child {
  color: var(--rf-brand-bright);
}
.od-total-row.is-commission {
  border-top-style: dashed;
}
.od-total-row.is-commission span {
  font-size: 12px;
  color: #a29b8d;
}
.od-total-row.is-net span {
  font-weight: 600;
}
.od-payment {
  margin-top: 14px;
  padding: 11px 13px;
  background: #252017;
  border-radius: 9px;
}
.od-payment-label {
  font-size: 11.5px;
  color: #a29b8d;
  margin-bottom: 3px;
}
.od-payment-value {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}
.od-unpaid {
  display: inline-block;
  padding: 1px 10px;
  border-radius: 10px;
  background: #dc4141;
  color: #fff;
  font-weight: 800;
  letter-spacing: 0.04em;
}

/* ---------------- "Paid" button + dialog ---------------- */
.od-btn-paid {
  padding: 0 16px;
  border: none;
  background: #3f9d4d;
  color: #fff;
}
.od-btn-paid:hover:not(:disabled) {
  background: #35873f;
}
.od-btn-paid:disabled {
  opacity: 0.5;
  cursor: default;
}
/* over the panel, inside the fixed .od-wrap */
.od-paid-scrim {
  position: absolute;
  inset: 0;
  z-index: 5;
  background: rgba(25, 23, 20, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.od-paid {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);
  padding: 22px 24px 18px;
  text-align: left;
}
.od-paid-title {
  font-size: 22px;
  line-height: 1.2;
  color: #191714;
}
.od-paid-sub {
  margin-top: 2px;
  font-size: 12.5px;
  color: #6f6a60;
}
.od-paid-label {
  margin: 16px 0 6px;
}
.od-paid-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.od-paid-method {
  flex: 1 1 auto;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  font: 500 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #2f2b25;
  cursor: pointer;
}
.od-paid-method:hover {
  background: #f6f4ef;
}
.od-paid-method.is-on {
  border-color: #3f9d4d;
  background: #eef7ef;
  color: #22622c;
  font-weight: 600;
}
.od-paid-date {
  height: 38px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
}
.od-paid-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/order-detail-panel.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;;;wEAGwE;AACxE;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,uEAAuE;EACvE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd;4EAC0E;EAC1E,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA,yEAAyE;AACzE;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;mEACmE;AACnE;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,gEAAgE;AAChE;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;iCACiC;AACjC;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,kEAAkE;AAClE;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,mDAAmD;AACnD;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;;;qCAGqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,8DAA8D;EAC9D,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;kEAEkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV","sourcesContent":["/* OrderDetailPanel — work order detail sliding over the list. */\n\n/* Pinned to the window, not the page: the list scrolls the whole window,\n   and an absolute panel the height of a long list scrolled its own content\n   out of view. Fixed, the panel is always one screen tall and its body\n   scrolls instead. Above the top bar (z 12), like the other overlays. */\n.od-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  justify-content: flex-end;\n}\n.od-scrim {\n  position: absolute;\n  inset: 0;\n  /* the list behind still scrolls under the wheel; the panel stays put */\n  background: rgba(25, 23, 20, 0.18);\n}\n.od-panel {\n  position: relative;\n  width: 840px;\n  max-width: 100%;\n  background: #fff;\n  border-left: 1px solid #ddd7cb;\n  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.14);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ---------------- header ---------------- */\n.od-head {\n  padding: 18px 24px 16px;\n  border-bottom: 1px solid #e2dcd0;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  flex-shrink: 0;\n  /* style.css styles bare <header> tags (bold, centered, margins) for the\n     legacy pages — reset so the name and sub line sit left with the meta. */\n  text-align: left;\n  font-weight: 400;\n  margin: 0;\n}\n.od-head-main {\n  flex-grow: 1;\n  min-width: 0;\n}\n.od-meta {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 5px;\n}\n.od-serial {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #8b8477;\n}\n.od-type {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  padding: 2px 7px;\n  border-radius: 4px;\n}\n.od-type.is-funeral {\n  color: var(--rf-brand-deep);\n  background: var(--rf-brand-tint);\n}\n.od-type.is-retail {\n  color: var(--rf-accent);\n  background: #e9f1f0;\n}\n.od-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #4a453c;\n}\n.od-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n.od-name {\n  font-size: 30px;\n  line-height: 1.1;\n  color: #191714;\n  margin: 0;\n  font-weight: 400;\n}\n.od-sub {\n  font-size: 13px;\n  color: #6f6a60;\n  margin-top: 5px;\n  text-wrap: pretty;\n}\n.od-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.od-actions .rf-btn {\n  height: 34px;\n  font-size: 12.5px;\n}\n.rf-icon-btn {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #8b8477;\n  font-size: 18px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.rf-icon-btn:hover {\n  background: #f4f1ea;\n}\n\n/* ---------------- body ---------------- */\n.od-body {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 18px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ---------------- timeline ---------------- */\n.od-timeline {\n  background: #faf8f3;\n  border: 1px solid #eee9df;\n  border-radius: 12px;\n  padding: 14px 18px;\n  display: flex;\n  align-items: flex-start;\n}\n.od-step {\n  flex-grow: 1;\n  padding-right: 14px;\n  min-width: 0;\n}\n.od-step-track {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.od-step-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #e0dacd;\n  flex-shrink: 0;\n}\n.od-step-line {\n  flex-grow: 1;\n  height: 2px;\n  background: #e2dcd0;\n}\n.od-step.is-done .od-step-dot,\n.od-step.is-done .od-step-line {\n  background: #4d7a52;\n}\n.od-step.is-active .od-step-dot {\n  background: #b0872f;\n}\n.od-step-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #a29b8d;\n}\n.od-step.is-done .od-step-label,\n.od-step.is-active .od-step-label {\n  color: #191714;\n}\n.od-step-time {\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n\n/* ---------------- facts ---------------- */\n.od-facts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.od-facts-label {\n  margin-bottom: 8px;\n  display: block;\n}\n.od-factcard {\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.od-fact {\n  display: flex;\n  gap: 12px;\n  padding: 9px 13px;\n  border-top: 1px solid #f0ece3;\n  font-size: 13px;\n}\n.od-fact:first-child {\n  border-top: none;\n}\n.od-fact-k {\n  width: 118px;\n  flex-shrink: 0;\n  color: #8b8477;\n}\n.od-fact-v {\n  color: #191714;\n  font-weight: 500;\n  text-wrap: pretty;\n}\n.od-fact-v.is-danger {\n  color: #a8483e;\n}\n/* a second line under the value — the orderer's phone under their name */\n.od-fact-sub {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #6f6a60;\n}\n.od-fact-v.is-muted {\n  color: #6f6a60;\n}\n\n/* ---------------- products ---------------- */\n.od-products-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.od-products-total {\n  font-size: 12.5px;\n  color: #8b8477;\n}\n.od-products-total b {\n  color: #191714;\n  font-weight: 600;\n}\n.od-productcard {\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.od-product {\n  padding: 11px 14px;\n  border-top: 1px solid #f0ece3;\n}\n.od-product-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n/* sash wording, bench comment and lid type under the product — full\n   width so a sentence reads as one, indented past the accent bar */\n.od-product-notes {\n  margin: 7px 0 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.od-product-note {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n.od-product-note-k {\n  width: 62px;\n  flex-shrink: 0;\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n}\n.od-product-note-v {\n  color: #2f2b25;\n  overflow-wrap: anywhere;\n}\n.od-product-note-v em {\n  color: #a8483e;\n  font-style: normal;\n  font-weight: 600;\n}\n/* sash wording and bench comment: free text, set apart from the facts */\n.od-product-note.is-text .od-product-note-v {\n  font-style: italic;\n  font-weight: 400;\n  color: #6b6458;\n}\n/* bench comments are instructions — red so they aren't missed */\n.od-product-note.is-comment .od-product-note-v {\n  color: #a8483e;\n}\n.od-product:first-child {\n  border-top: none;\n}\n.od-product-accent {\n  width: 4px;\n  height: 30px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n/* the name takes up to 70% of the card before it wraps; qty and price\n   are pushed to the right edge */\n.od-product-text {\n  flex: 0 1 70%;\n  max-width: 70%;\n  min-width: 0;\n  margin-right: auto;\n}\n.od-product-name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n}\n.od-product-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.od-product-qty {\n  flex-shrink: 0;\n  white-space: nowrap;\n  font-size: 13px;\n  color: #4a453c;\n}\n.od-product-price {\n  min-width: 74px;\n  flex-shrink: 0;\n  text-align: right;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n/* \"2 × $440.00 each + sash $30.00\" — right under the line total */\n.od-product-calc {\n  margin-top: 3px;\n  text-align: right;\n  font-size: 12px;\n  color: #6f6a60;\n}\n.od-product-foot {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n.od-product-who {\n  font-size: 11px;\n  color: #4a453c;\n}\n.od-product-state {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  padding: 2px 7px;\n  border-radius: 20px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.od-product-state.is-ok {\n  color: #4d7a52;\n  background: #eaf1e9;\n}\n.od-product-state.is-warn {\n  color: #b0872f;\n  background: #f9f1de;\n}\n.od-product-state.is-idle {\n  color: #8b8477;\n  background: #f4f1ea;\n}\n\n/* ---------------- footer ---------------- */\n.od-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0 4px;\n  font-size: 12px;\n  color: #a29b8d;\n}\n.od-delete {\n  border: none;\n  background: none;\n  padding: 0;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #a8483e;\n  cursor: pointer;\n}\n\n/* ---------------- responsive: tablet ---------------- */\n@media (max-width: 1200px) {\n  .od-panel {\n    width: 100%;\n  }\n  .od-facts {\n    grid-template-columns: 1fr;\n  }\n  .od-timeline {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n}\n\n/* ---------------- history view ---------------- */\n.od-history {\n  gap: 14px;\n}\n.od-hist-intro {\n  font-size: 12.5px;\n  color: #6f6a60;\n}\n.od-hist-count {\n  margin-left: 8px;\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.od-hist-state {\n  padding: 14px 16px;\n  border: 1px dashed #e2dcd0;\n  border-radius: 10px;\n  font-size: 12.5px;\n  color: #6f6a60;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.od-hist-state.is-error {\n  border-style: solid;\n  border-color: #e8c6c0;\n  background: #fbf3f1;\n  color: #8a3b2f;\n}\n.od-hist-retry {\n  margin-left: auto;\n}\n.od-hist-more {\n  align-self: flex-start;\n  margin-top: 2px;\n}\n.od-hist-list {\n  display: flex;\n  flex-direction: column;\n}\n.od-hist-node {\n  display: flex;\n  gap: 13px;\n}\n.od-hist-track {\n  width: 30px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.od-hist-dot {\n  width: 11px;\n  height: 11px;\n  margin-top: 4px;\n  border-radius: 50%;\n  border: 2px solid var(--rf-brand-lite);\n  background: #fff;\n  flex-shrink: 0;\n}\n.od-hist-node.is-create .od-hist-dot {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n}\n.od-hist-node.is-handover .od-hist-dot,\n.od-hist-node.is-run .od-hist-dot {\n  background: var(--rf-brand-lite);\n}\n.od-hist-node.is-delete .od-hist-dot {\n  background: #c25a48;\n  border-color: #c25a48;\n}\n.od-hist-node.is-delete .od-hist-action {\n  color: #8a3b2f;\n}\n\n/* business section marker. The trail is newest first, so a marker sits\n   BELOW the entries it belongs to: read bottom-up it opens the section,\n   the way the chronology runs. The same line passes through it, so a\n   handover reads as a new chapter. */\n.od-hist-bizchip {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.od-hist-bizchip img {\n  max-width: 24px;\n  max-height: 24px;\n  object-fit: contain;\n}\n.od-hist-bizchip span {\n  font: 700 11px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand-deep);\n}\n.od-hist-bizcard {\n  padding-bottom: 14px;\n}\n.od-hist-node.is-business:not(:first-child) .od-hist-bizcard {\n  padding-top: 2px;\n}\n.od-hist-bizeyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.od-hist-bizname {\n  font-size: 17px;\n  color: #191714;\n  margin-top: 2px;\n}\n.od-hist-line {\n  flex-grow: 1;\n  width: 1.5px;\n  background: #e7e3da;\n  margin: 3px 0;\n}\n.od-hist-card {\n  flex-grow: 1;\n  min-width: 0;\n  padding: 0 0 18px;\n}\n.od-hist-node:last-child .od-hist-card {\n  padding-bottom: 4px;\n}\n.od-hist-toprow {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.od-hist-action {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.od-hist-when {\n  margin-left: auto;\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.od-hist-who {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 5px;\n  font-size: 12.5px;\n  color: #4a453c;\n}\n.od-hist-chip {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #f0e3c8;\n  color: var(--rf-brand-deep);\n  font: 700 10px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.od-hist-chip.is-system {\n  background: #ecebe7;\n  color: #6f6a60;\n}\n.od-hist-summary {\n  margin-top: 5px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #6f6a60;\n  text-wrap: pretty;\n}\n.od-hist-changes {\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n.od-hist-changes li {\n  display: flex;\n  flex-direction: column;\n  padding: 4px 0 0;\n  border-top: 1px dashed #e6e3dc;\n}\n.od-hist-changes li:first-child {\n  border-top: 0;\n  padding-top: 0;\n}\n.od-hist-field {\n  font-weight: 600;\n  color: #3d3a33;\n}\n.od-hist-diff {\n  color: #6f6a60;\n  overflow-wrap: anywhere;\n}\n.od-hist-arrow {\n  color: #a8a296;\n  margin: 0 2px;\n}\n\n/* ---------------- transfers ----------------\n   The order arrived from another business, or is on its way to one. Both\n   sit in the panel head area so they read before anything else. */\n.od-from {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 2px 10px;\n  border-radius: 11px;\n  background: #f3ece0;\n  border: 1px solid #e4d8c2;\n  color: var(--rf-brand-deep);\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n}\n.od-from::before {\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--rf-brand-lite);\n}\n\n.od-txbanner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 26px;\n  background: #fbf3e2;\n  border-bottom: 1px solid #ecdcb8;\n}\n.od-txbanner-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #c79a2f;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 4px rgba(199, 154, 47, 0.16);\n}\n.od-txbanner-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n.od-txbanner-text b {\n  font-size: 13px;\n  color: var(--rf-brand-deep);\n}\n.od-txbanner-text span {\n  font-size: 12px;\n  color: #8a7f6a;\n}\n.od-txbanner .rf-btn {\n  flex-shrink: 0;\n}\n\n.od-hist-node.is-transfer .od-hist-dot {\n  background: #6f8fa8;\n  border-color: #6f8fa8;\n}\n.od-hist-node.is-transfer .od-hist-action {\n  color: #40617a;\n}\n\n/* ---------- order total (mirrors .rv-total-card on the review step) ---------- */\n.od-total {\n  width: 60%;\n  align-self: flex-end;\n  margin-top: 100px;\n  background: #191714;\n  border-radius: 12px;\n  padding: 18px 20px;\n  color: #fff;\n}\n@media (max-width: 720px) {\n  .od-total {\n    width: 100%;\n  }\n}\n.od-total-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  margin-bottom: 12px;\n}\n.od-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 0;\n  border-top: 1px solid #302b23;\n  font-size: 12.5px;\n}\n.od-total-row span:first-child {\n  color: #b8b1a3;\n}\n.od-total-row span:last-child {\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n}\n.od-total-row.is-total {\n  font-size: 16px;\n  font-weight: 600;\n}\n.od-total-row.is-total span:first-child {\n  color: #fff;\n}\n.od-total-row.is-total span:last-child {\n  color: var(--rf-brand-bright);\n}\n.od-total-row.is-commission {\n  border-top-style: dashed;\n}\n.od-total-row.is-commission span {\n  font-size: 12px;\n  color: #a29b8d;\n}\n.od-total-row.is-net span {\n  font-weight: 600;\n}\n.od-payment {\n  margin-top: 14px;\n  padding: 11px 13px;\n  background: #252017;\n  border-radius: 9px;\n}\n.od-payment-label {\n  font-size: 11.5px;\n  color: #a29b8d;\n  margin-bottom: 3px;\n}\n.od-payment-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n.od-unpaid {\n  display: inline-block;\n  padding: 1px 10px;\n  border-radius: 10px;\n  background: #dc4141;\n  color: #fff;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n/* ---------------- \"Paid\" button + dialog ---------------- */\n.od-btn-paid {\n  padding: 0 16px;\n  border: none;\n  background: #3f9d4d;\n  color: #fff;\n}\n.od-btn-paid:hover:not(:disabled) {\n  background: #35873f;\n}\n.od-btn-paid:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n/* over the panel, inside the fixed .od-wrap */\n.od-paid-scrim {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  background: rgba(25, 23, 20, 0.32);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.od-paid {\n  width: 100%;\n  max-width: 400px;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);\n  padding: 22px 24px 18px;\n  text-align: left;\n}\n.od-paid-title {\n  font-size: 22px;\n  line-height: 1.2;\n  color: #191714;\n}\n.od-paid-sub {\n  margin-top: 2px;\n  font-size: 12.5px;\n  color: #6f6a60;\n}\n.od-paid-label {\n  margin: 16px 0 6px;\n}\n.od-paid-methods {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.od-paid-method {\n  flex: 1 1 auto;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  font: 500 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #2f2b25;\n  cursor: pointer;\n}\n.od-paid-method:hover {\n  background: #f6f4ef;\n}\n.od-paid-method.is-on {\n  border-color: #3f9d4d;\n  background: #eef7ef;\n  color: #22622c;\n  font-weight: 600;\n}\n.od-paid-date {\n  height: 38px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n}\n.od-paid-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
